import { formatDate } from '@angular/common';
import { HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { DateUtil } from './utility';

export class HttpUtil {
  public static toHttpHeaders(params?: object): HttpHeaders {
    var httpHeaders = new HttpHeaders();

    if (params == null) {
      return httpHeaders;
    }

    for (let [key, value] of Object.entries(params)) {
      if (value == null) {
        continue;
      } else if (Array.isArray(value)) {
        for (let singleValue of value) {
          httpHeaders = httpHeaders.append(key, singleValue.toString());
        }
      } else {
        httpHeaders = httpHeaders.append(key, value.toString());
      }
    }

    return httpHeaders;
  }

  public static toHttpParams(params: object): HttpParams {
    var httpParams = new HttpParams();

    for (let [key, value] of Object.entries(params)) {
      if (value == null) {
        continue;
      } else if (Array.isArray(value)) {
        for (let singleValue of value) {
          httpParams = httpParams.append(key, singleValue.toString());
        }
      } else {
        httpParams = httpParams.append(key, value.toString());
      }
    }

    return httpParams;
  }

  public static download(response: HttpResponse<Blob>): void {
    // Extract content disposition header
    let contentDisposition = response.headers.get('content-disposition');
    let filename: string | null = null;

    if (contentDisposition != null) {
      const [, filenameMatch] = contentDisposition.match(/filename="?([^"]+)"?/) || [];
      const [, filenameStarMatch] = contentDisposition.match(/filename\*=(?:.*UTF-8'')?([^;]+)/) || [];

      if (filenameStarMatch != null) {
        filename = decodeURIComponent(filenameStarMatch);
      } else if (filename != null) {
        filename = filenameMatch;
      }
    }

    if (filename == null) {
      filename = DateUtil.getLocalNow().format('YYYYMMDD_HHmmss');
    }

    // Check if we're in a browser environment
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      let url = window.URL.createObjectURL(response.body!);
      let link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }
}
